import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins, ChartOptions } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { StackedAreaChart } from '../../../charting/index';

export interface IStackedAreaChartDirective extends ng.IDirective {
}

export interface IStackedAreaChartDirectiveScope extends ng.IScope {
    chartData: any;
    options: any;
    id: any;
    series: any;
}

export class StackedAreaChartDirective extends ChartDirectiveBase implements IStackedAreaChartDirective {
    static directiveId = 'wtStackedAreaChart';

    constructor() {
        super();
        this.scope = {
            chartData: '=',
            options: '=',
            id: '@',
            series: '='
        };
    }

    link(scope: IStackedAreaChartDirectiveScope, element, attrs, controller) {
        const containerName = attrs.id;
        element.attr('id', containerName);
        const margins = new Margins(0, 0, 10, 0);
        const svgManager = new SvgManager(containerName, margins);
        const options = new ChartOptions(60, 20, 0, 50);
        const plot = new StackedAreaChart(options, svgManager);

        scope.$watchCollection(() => scope.options.display, () => {
            plot.yMin(scope.options.display.yMin);
            plot.yMax(scope.options.display.yMax);
            plot.yAxisFormat(scope.options.display.yAxisFormat);
        });

        scope.$watch(() => scope.options.title, () => {
            plot.titleText(scope.options.title);
        });
        scope.$watch(() => scope.options.isTitleVisible, () => {
            plot.isTitleVisible(scope.options.isTitleVisible);
        });
        scope.$watch(() => scope.options.isLegendVisible, () => {
            plot.isLegendVisible(scope.options.isLegendVisible);
        });
        scope.$watchCollection(() => scope.chartData, () => {
            plot.update(scope.chartData);
        });
        scope.$watch(() => scope.series, () => {
            plot.updateSeries(scope.series);
        }, true);
    }
}